module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.isFullyLoaded) ? _c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [(_vm.alertaRegistrarNovaPreRetirada) ? _c('div', {
    staticClass: "bg-warning lter b-b wrapper-md m-t"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h4 text-black"
  }, [_c('strong', [_vm._v("Atenção")]), _c('br'), _vm._v("\n            Confira os dados da GRV antes de registrar uma nova pré-retirada\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "estoqueHeader"
  }, [_c('div', {
    staticClass: "grv-bar"
  }, [_c('div', [_c('div', {
    staticClass: "grv-status-div"
  }, [_vm._v("GRV "), _c('strong', [_vm._v(_vm._s(_vm.data.numero))]), _vm._v(" criada\n            " + _vm._s(_vm.moment(_vm.data.data.date).fromNow()) + " / " + _vm._s(_vm.data.placaOriginal ? 'Placa Original' : 'Chassi') + ": "), _c('strong', [_vm._v(_vm._s(_vm.data.placaOriginal || _vm.data.chassi || '-'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.marca || '-') + " / " + _vm._s(_vm.data.modelo || '-') + " - " + _vm._s(_vm.data.cor || '-') + " - " + _vm._s(_vm.data.ano || '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-right column-flex"
  }, [_c('div', {
    staticClass: "text-right m-r-xxl"
  }, [_vm._v("\n            " + _vm._s(_vm.data.bemCategoria.nome) + "\n            "), _c('br'), _vm._v(" "), (_vm.isTipoRemocaoRodando) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Tipo de remoção: RODANDO")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right hidden-print m-t-sm",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'roubo-furto.list',
        query: {
          grv: _vm.data.numero
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "posbar"
  }, [_c('div', {
    staticClass: "grv-status"
  }, [_c('div', [_vm._v("Situação atual")]), _vm._v(" "), _c('div', {
    staticClass: "status-insights"
  }, [_vm._v(_vm._s(_vm.StatusTitle(_vm.data.status)))]), _vm._v(" "), (_vm.data.status === _vm.STATUS_NO_LEILAO && _vm.ACL.check('alterar_status_grv', _vm.currentUser.id)) ? _c('div', [_c('button', {
    staticClass: "btn btn-danger font-bold btnlock",
    on: {
      "click": _vm.excluirLote
    }
  }, [_vm._v("\n              Retirar lote do leilão\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('alterar_status_grv', _vm.currentUser.id)) ? _c('btn-altera-status-grv', {
    on: {
      "statusAlterado": _vm.start
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grv-status cursor-pointer_"
  }, [_c('div', {
    staticClass: "status-insights text-center"
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "20px"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.calculo.base.diarias))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex flex-center"
  }, [_vm._v("diária" + _vm._s(+_vm.calculo.base.diarias !== 1 ? 's' : ''))]), _vm._v(" "), (_vm.ACL.check('corrigir_estadas', _vm.currentUser.id)) ? _c('div', {
    staticClass: "m-t-sm row-flex flex-center"
  }, [_c('btn-corrigir-diarias', {
    attrs: {
      "quantidade-diarias-atual": _vm.calculo.base.diarias,
      "grv-id": _vm.$route.params.id
    },
    on: {
      "corrigido": _vm.start
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [(_vm.isAdministradorExclusivo) ? _c('btn-alterar-regra-meio-dia', {
    attrs: {
      "grv-id": _vm.$route.params.id,
      "is-regra-meio-dia-ativada": !_vm.calculo.base.desabilitarRegraMeioDia,
      "ocultar-apos-meio-dia": ""
    },
    on: {
      "alterado": _vm.start
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grv-status cursor-pointer_"
  }, [_c('div', {
    staticClass: "status-insights text-center"
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "20px"
    }
  }) : _c('span', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.base.saldoDevedor)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex flex-center"
  }, [_vm._v("saldo devedor ")]), _vm._v(" "), (_vm.calculo.base.cobrarTaxaNotificacaoAR) ? _c('div', {
    staticClass: "row-flex flex-center text-sm text-danger-dker"
  }, [_vm._v("\n            +R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.custos.valorTaxaNotificacaoAR)) + " taxa de notificação AR\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grv-status gmin cursor-pointer_"
  }, [_c('div', {
    staticClass: "status-insights text-center"
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "20px"
    }
  }) : _c('div', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.custos.valorDiaria)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex flex-center"
  }, [_vm._v("diária ")])]), _vm._v(" "), _c('div', {
    staticClass: "grv-status gmin cursor-pointer_"
  }, [_c('div', {
    staticClass: "status-insights text-center"
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "20px"
    }
  }) : _c('div', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.custos.valorReboque)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row-flex flex-center"
  }, [_vm._v("reboque ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "newsfeed"
  }, [_c('card-news-item-resumo', {
    attrs: {
      "grv": _vm.data,
      "data-limite-gratuidade": _vm.calculo.base.dataLimiteGratuidade,
      "datas-extra-model": _vm.extraModel,
      "data-agendamento": _vm.calculo.base.dataAgendamento
    }
  }), _vm._v(" "), (!_vm.isRetiradoPorLeilao && !_vm.isDataUltimoLeilaoMenorQueHoje) ? _c('card-news-item', {
    attrs: {
      "title": "Pré-Retirada"
    }
  }, [_c('div', {
    staticClass: "row m-t"
  }, [(!_vm.data.preretiradas) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n            Nenhuma pré-retirada registrada\n            "), _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'preretirada.adicionar',
          params: {
            id: _vm.data.id
          }
        })
      }
    }
  }, [_vm._v("\n                Registrar pré-retirada\n              ")])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.data.preretiradas), function(preretirada) {
    return _c('div', {
      staticClass: "m-b"
    }, [_vm._v("\n              Registrada para " + _vm._s(_vm.moment(preretirada.dataPrevista.date).format('LL')) + " no valor de R$\n              " + _vm._s(_vm._f("moeda")(preretirada.valor)) + " e status "), _c('strong', {
      class: 'text-' + _vm.StatusPreRetirada[preretirada.status].class
    }, [_vm._v(_vm._s(_vm.StatusTitlePreRetirada(preretirada.status)))]), _vm._v(".\n              "), _c('br'), _vm._v("\n              Favorecido: " + _vm._s(_vm.FAVORECIDO_STRINGS[preretirada.favorecido]) + "\n              "), _c('div', [(preretirada.status === 0 && preretirada.favorecido === _vm.FAVORECIDO_DETRO) ? _c('a', {
      staticClass: "btn btn-xs btn-primary btn-block m-t-xs",
      attrs: {
        "href": preretirada.urlBoleto,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-barcode"
    }), _vm._v(" Ver boleto\n                ")]) : _vm._e(), _vm._v(" "), (preretirada.status === 0 && preretirada.favorecido === _vm.FAVORECIDO_APL) ? _c('a', {
      staticClass: "btn btn-xs btn-primary btn-block m-t-xs",
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.emitirGuiaPagamento(preretirada)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-barcode"
    }), _vm._v(" Guia de pagamento\n                ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs btn-default btn-block m-t-xs",
      on: {
        "click": function($event) {
          return _vm.consultaPagamento(preretirada)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    }), _vm._v(" Consultar pagamento\n                ")]), _vm._v(" "), (_vm.isAdministradorExclusivo && preretirada.status === 3) ? _c('a', {
      staticClass: "btn btn-xs btn-danger btn-block m-t-xs",
      on: {
        "click": function($event) {
          return _vm.excluirPreRetirada(preretirada.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir pré-retirada\n                ")]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    attrs: {
      "disabled": _vm.ACL.check('coordES', _vm.currentUser.id)
    },
    on: {
      "click": _vm.registrarPreRetirada
    }
  }, [_vm._v("\n                Registrar nova pré-retirada\n              ")])])], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.isRetiradoPorLeilao) ? _c('card-news-item-pagamento', {
    attrs: {
      "calculo": _vm.calculo,
      "preretiradas": _vm.data.preretiradas,
      "grvId": _vm.data.id,
      "grvPatioPix": _vm.data.patio.chavePix,
      "prospsTxid": _vm.data.txidPixPatio
    }
  }) : _vm._e(), _vm._v(" "), _c('card-news-item', {
    staticClass: "hidden-print",
    attrs: {
      "title": "Retirada"
    }
  }, [(!_vm.data.retirada) ? _c('div', {
    staticClass: "hidden-print"
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "100%"
    }
  }) : _c('div', {
    staticClass: "row m-t"
  }, [(_vm.hasPendencias) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n              Este veículo ainda "), _c('strong', {
    staticClass: "nao-apto"
  }, [_vm._v("não está apto")]), _vm._v(" para retirada. Pendências:\n              "), _c('div', {
    staticClass: "m-t"
  }, [_c('ul', [(!_vm.data.preretiradas) ? _c('li', [_vm._v("Gerar pré-retirada")]) : _vm._e(), _vm._v(" "), (_vm.data.preretiradas && _vm.calculo.base.valorPago === 0) ? _c('li', [_vm._v("Efetuar pagamento.")]) : _vm._e(), _vm._v(" "), (_vm.data.preretiradas && _vm.calculo.base.saldoDevedor > 0) ? _c('li', [_vm._v("Valore(s) pago(s) não batem com o\n                    saldo devedor. Resta a pagar "), _c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(_vm.calculo.base.saldoDevedor)))]), _vm._v(". Registre\n                    uma nova pré-retirada para que seja efetuado o pagamento.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.data.preretiradas && _vm.calculo.base.saldoDevedor < 0) ? _c('li', [_vm._v("Inconsistência nos valores pagos.\n                    Foi efetuado um pagamento superior ao valor devido, faça o reembolso de "), _c('strong', {
    staticClass: "text-success"
  }, [_vm._v("R$" + _vm._s(_vm._f("moeda")(Math.abs(_vm.calculo.base.saldoDevedor))))]), _vm._v(".\n                    Caso queira efetuar a retirada mesmo assim, prossiga com o processo.\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.retirada
    }
  }, [_vm._v("Registrar retirada mesmo assim")])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center text-3x"
  }, [_c('i', {
    staticClass: "fa fa-check-circle text-success"
  })]), _vm._v("\n              Este veículo está "), _c('strong', {
    staticClass: "apto"
  }, [_vm._v("apto")]), _vm._v(" para retirada.\n              "), _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    on: {
      "click": _vm.retirada
    }
  }, [_vm._v("Registrar retirada")])])])])], 1) : _c('div', {
    staticClass: "hidden-print"
  }, [_vm._v("\n          Veículo retirado " + _vm._s(_vm.moment(_vm.data.retirada.dataRetirada.date).format('LLL')) + "\n          "), _c('div', {
    staticClass: "m-t"
  }, [_c('a', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.emitirDocumentoRetirada
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-sm"
  }), _vm._v(" Emitir retirada")])]), _vm._v(" "), (_vm.ACL.check('alterar_retirada_grv', _vm.currentUser.id)) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.retirada
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-sm"
  }), _vm._v("Editar retirada")])]) : _vm._e(), _vm._v(" "), (_vm.isAdministradorExclusivo) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block",
    on: {
      "click": _vm.excluirRetirada
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o m-r-sm"
  }), _vm._v("Excluir retirada")])]) : _vm._e()]), _vm._v(" "), _c('btn-upload-arquivo-grv', {
    staticClass: "m-t",
    attrs: {
      "grv": _vm.data
    },
    on: {
      "reload": _vm.start
    }
  })], 1), _vm._v(" "), (_vm.isGrvPolicia) ? _c('card-news-item', {
    staticClass: "hidden-print",
    attrs: {
      "title": "GEV"
    }
  }, [(true) ? _c('div', [_c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n              Este veículo foi apreendido pela Polícia Civil. Faz-se necessário, portanto, o cadastro da Guia de Entrega de Veículo (GEV) "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-t"
  }, [(!_vm.data.gev) ? _c('button', {
    staticClass: "btn btn-danger btn-block",
    on: {
      "click": _vm.openFormGev
    }
  }, [_vm._v("Cadastrar GEV")]) : _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.openFormGev
    }
  }, [_vm._v("Visualizar/Editar GEV")]), _vm._v(" "), (_vm.data.gev) ? _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.emitirGev
    }
  }, [_vm._v("Imprimir GEV")]) : _vm._e()])])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('log-detro-grv-patio'), _vm._v(" "), (_vm.showConsultaPagamento) ? _c('popup-viewer', {
    attrs: {
      "title": 'Consultar Pagamento de Boleto GRV ' + _vm.data.numero
    },
    on: {
      "close": _vm.closeConsultaPagamento
    }
  }, [_c('grv-consulta-pagamento', {
    attrs: {
      "preretirada": _vm.preretiradaConsulta
    },
    on: {
      "statusPagamentoAlterado": _vm.start
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormGev) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de GEV"
    },
    on: {
      "close": _vm.closeFormGev
    }
  }, [_c('gev', {
    attrs: {
      "grv": _vm.data,
      "gevId": _vm.data.gev
    },
    on: {
      "finishSubmit": _vm.closeFormGev
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c68594c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/GrvPatio.vue
// module id = 1679
// module chunks = 18